import { motion } from 'framer-motion';
import * as Icons from 'lucide-react';
import Button from '../ui/Button';
import { formatPrice } from '../../utils/formatters';
import { scrollToSection } from '../../hooks/useScrollSpy';

export default function SectionFormules({ formules }) {
  return (
    <section id="formules" className="section-padding bg-black">
      <div className="container mx-auto px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">Grille Tarifaire</h2>
          <p className="text-xl text-secondary-200 max-w-3xl mx-auto mb-4">
            Prix dégressif : plus le volume augmente, plus le tarif unitaire baisse.
          </p>
          <p className="text-lg text-primary-400 font-semibold">
            Prix plancher : 20€/vidéo (volume 100)
          </p>
        </motion.div>

        {/* Tableau tarifaire */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="overflow-x-auto"
        >
          <div className="bg-secondary-900 rounded-2xl p-4 md:p-8 shadow-2xl border border-secondary-700 min-w-[800px]">
            <table className="w-full">
              <thead>
                <tr className="border-b-2 border-secondary-700">
                  <th className="text-left py-4 px-4 text-secondary-200 font-semibold">Volume</th>
                  <th className="text-center py-4 px-4 text-secondary-200 font-semibold">Prix/vidéo</th>
                  <th className="text-center py-4 px-4 text-secondary-200 font-semibold">Total HT</th>
                  <th className="text-center py-4 px-4 text-secondary-200 font-semibold">Option Premium</th>
                </tr>
              </thead>
              <tbody>
                {formules.map((formule, index) => (
                  <tr
                    key={formule.id}
                    className="border-b border-secondary-800 transition-all hover:bg-secondary-800/50"
                  >
                    {/* Volume */}
                    <td className="py-6 px-4">
                      <div className="flex flex-col">
                        <span className="text-white font-bold text-lg">{formule.name}</span>
                        <span className="text-primary-400 font-semibold">{formule.tagline}</span>
                      </div>
                    </td>

                    {/* Prix unitaire */}
                    <td className="py-6 px-4 text-center">
                      <span className="text-2xl font-bold text-white">
                        {formule.pricing.tjm}€
                      </span>
                      <span className="text-secondary-300 text-sm block">/vidéo</span>
                    </td>

                    {/* Total */}
                    <td className="py-6 px-4 text-center">
                      <span className="text-2xl font-bold text-primary-500">
                        {formatPrice(formule.pricing.finalPrice)}
                      </span>
                    </td>

                    {/* Option Premium */}
                    <td className="py-6 px-4 text-center">
                      {formule.specialClause ? (
                        <div className="flex flex-col items-center">
                          <span className="text-amber-400 font-semibold">
                            {formule.specialClause.title.match(/\+(\d+€)/)?.[1] || 'Disponible'}
                          </span>
                          <span className="text-xs text-secondary-300 mt-1">pilotage créatif</span>
                        </div>
                      ) : (
                        <span className="text-secondary-500">-</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </motion.div>

        {/* CTA Option Premium */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-8 max-w-4xl mx-auto"
        >
          <div className="bg-gradient-to-r from-amber-900/30 to-orange-900/30 rounded-xl p-6 border-2 border-amber-500/50">
            <div className="flex items-start gap-4">
              <Icons.Sparkles className="text-amber-400 flex-shrink-0" size={32} />
              <div>
                <h3 className="text-white font-bold text-xl mb-2">Option Premium : Pilotage créatif</h3>
                <p className="text-amber-100">
                  Avec l'option Premium, je ne fais pas que monter les vidéos : je scénarise votre communication.
                  Je vous proposerai un cadre clair sur les images à filmer et sur la manière de les utiliser,
                  afin que chaque vidéo raconte quelque chose et s'intègre dans une stratégie globale.
                  Vous gagnez en efficacité, en cohérence et en sérénité, tout en évitant les essais au hasard.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
